const seoSettingKey = {
  description: 'description',
  favicon: 'favicon',
  title: 'title',
  slug: 'urlSlug',
  seoSetting: 'seoSetting',
  slugValid: 'slugValid',
};
export { seoSettingKey };
